import { ref } from 'vue'
const showConfirmation = ref(false)
const isConfirmed = ref(false)

export const useConfirmation = () => {
  const toggleShowConfirmation = state => {
    showConfirmation.value = state
    if (!state) isConfirmed.value = false
  }

  const confirmAction = isConfirmedVal => {
    isConfirmed.value = isConfirmedVal
    toggleShowConfirmation(isConfirmed.value)
  }

  return {
    toggleShowConfirmation,
    showConfirmation,
    confirmAction,
    isConfirmed,
  }
}
